<template>
  <w-sliding-popup ref="popup" :title="`[${popupParams.label}] 조치 계획`" width="1400px">
    <el-tabs slot="content" class="content-tap" type="card" v-model="activeTab" @tab-click="onChangeMenu">
      <el-tab-pane label="요약" name="WSummary" class="h100 w100">
        <w-maintenance-hist-summary-view ref="summary" :popup-params="popupParams" ></w-maintenance-hist-summary-view>
      </el-tab-pane>
      <el-tab-pane label="특이사항" name="WDetail" class="h100 w100">
        <w-maintenance-hist-detail-view ref="detail" :popup-params="popupParams" ></w-maintenance-hist-detail-view>
      </el-tab-pane>
    </el-tabs>
  </w-sliding-popup>
</template>

<script>
import WMaintenanceHistSummaryView from './components/MaintenanceHistSummaryView';
import WMaintenanceHistDetailView from './components/MaintenanceHistDetailView';

export default {
  name: 'WMaintenanceHistPopup',
  components: {
    WMaintenanceHistSummaryView,
    WMaintenanceHistDetailView,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: 'WSummary',
    };
  },
  methods: {
    open() {
      this.$refs.popup.visible = true;
      this.$nextTick(() => {
        this.$refs.summary.loadData();
      });
    },
    close() {
      this.$refs.popup.close();
    },
    onChangeMenu(menu) {
      // this.activeMenu = menu.name;
      if (menu.name === 'WSummary') {
        this.$refs.summary.loadData();
      } else {
        this.$refs.detail.loadData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/MaintenanceHistPopup.vue